import { GetSystemUserListResponse } from '@/services';

import { formatDate, map } from 'utils';

export const formatSystemUserDetail = (
	input: GetSystemUserListResponse['content'][number]
) => {
	return {
		...input,
		company: '인조이웍스',
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
	};
};

export const formatSystemUserList = (
	input: GetSystemUserListResponse['content']
) => {
	return map(input, formatSystemUserDetail);
};
